import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AuthComponent } from './auth.component';
import { ForgotPasswordInvalidTokenComponent } from './components/forgot-password-invalid-token/forgot-password-invalid-token.component';
import { ForgotPasswordResetComponent } from './components/forgot-password-reset/forgot-password-reset.component';
import { ForgotPasswordTokenResolverGuard } from './components/forgot-password-reset/forgot-password-token-resolver.guard';
import { ForgotPasswordComponent } from './components/forgot-password/forgot-password.component';
import { LoginComponent } from './components/login/login.component';
import { AuthEventInvalidTokenComponent } from './components/auth-event-invalid-token/auth-event-invalid-token.component';
import { AuthEventComponent } from './components/auth-event/auth-event.component';
import { AuthEventTokenResolverGuard } from './components/auth-event/auth-event-token-resolver.guard';

const routes: Routes = [
  {
    path: '',
    component: AuthComponent,
    children: [
      {
        path: '',
        redirectTo: 'login',
        pathMatch: 'full',
      },
      {
        path: 'login',
        component: LoginComponent,
        data: { returnUrl: window.location.pathname },
      },
      {
        path: 'forgot-password',
        component: ForgotPasswordComponent,
      },
      {
        path: 'forgot-password-reset/:token',
        component: ForgotPasswordResetComponent,
        resolve: {
          user: ForgotPasswordTokenResolverGuard,
        },
      },
      {
        path: 'forgot-password-invalid-token',
        component: ForgotPasswordInvalidTokenComponent,
      },
      {
        path: 'event/:token',
        component: AuthEventComponent,
        resolve: {
          accessTokenRes: AuthEventTokenResolverGuard,
        },
      },
      {
        path: 'event-invalid-token',
        component: AuthEventInvalidTokenComponent,
      },
      { path: '', redirectTo: 'login', pathMatch: 'full' },
      { path: '**', redirectTo: 'login', pathMatch: 'full' },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AuthRoutingModule {}
